export default __webpack_public_path__ + "static/uk-booking-e9d177fce24df1b746388fbc0e2e1c3f.jpg";